import { useLessonRoomStore } from '@stores/lesson-room'

import { useShowLessonApi } from '@composables/api/classroom/show-lesson.hook'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const bookingId = Number(to.params.booking)

  const lessonRoomStore = useLessonRoomStore()
  const { showLesson } = useShowLessonApi()

  const lesson = await showLesson(bookingId)

  if (!lesson) {
    return navigateTo('/')
  }

  // Set together with the booking: the flag is an entry-time snapshot (ping/WS booking
  // refreshes carry no is_last_lesson and never change the booking id without a remount).
  lessonRoomStore.setBooking(lesson.booking)
  lessonRoomStore.setLastLesson(lesson.isLastLesson)
})